import { Dispatch } from "redux"
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getSucursals = () => async (dispatch: Dispatch) => {
    const { data, status } = await Axios.get('/api/sucursal/getall/', {
        headers: { auth: localStorage.getItem('jwt') }
    })
    if (status === 200) {
        dispatch({
            type: 'SUCURSAL_GETALL_SUCCESS',
            payload: data
        })
    }
}

export const importSucursalsFromEbroker = () => async (dispatch: Dispatch) => {
    dispatch({
        type: 'SUCURSALS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/sucursal/getallebroker/', {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200) {
            dispatch({
                type: 'SUCURSALS_IMPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SUCURSALS_NOT_LOADING'
        })
    }
}

export const addReport = (id: string, reportData: any) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/sucursal/registerreport/' + id, reportData, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200) {
            dispatch({
                type: 'SUCURSAL_ADD_REPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SUCURSAL_ERROR'
        })
    }
}

export const deleteReport = (id: string, reportId: string) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/sucursal/deletereport/' + id + '/' + reportId, {}, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200) {
            dispatch({
                type: 'SUCURSAL_DELETE_REPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SUCURSAL_ERROR'
        })
    }
}

export const editReport = (id: string, reportId: string, reportData: any) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/sucursal/editreport/' + id + '/' + reportId, reportData, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200) {
            dispatch({
                type: 'SUCURSAL_EDIT_REPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SUCURSAL_ERROR'
        })
    }
}

export const getSucursalSettings = (ebrokerId: string | number) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.get('/api/sucursal/getsettings/' + ebrokerId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SUCURSAL_GET_SETTINGS_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'SUCURSAL_ERROR' })
    }
}

export const updateSucursalSettings = (ebrokerId: string | number, settings: { showHSP: boolean, showComisiones: boolean }) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/sucursal/updatesettings/' + ebrokerId, settings, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SUCURSAL_UPDATE_SETTINGS_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'SUCURSAL_ERROR' })
    }
}

export const getAllReports = (id: string) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.get('/api/sucursal/getallreports/' + id, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200) {
            dispatch({
                type: 'SUCURSAL_GET_ALL_REPORTS_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SUCURSAL_ERROR'
        })
    }
}